/**
 * Simple template string interpolation.
 * Replaces `{key}` placeholders with values from the vars object.
 *
 * @example
 * t('Hello {name}, you have {count} messages', { name: 'Alice', count: 5 })
 * // => 'Hello Alice, you have 5 messages'
 *
 * @example
 * t('Missing {key} is empty', {})
 * // => 'Missing  is empty'
 */
export const t = (
  template: string | undefined | null,
  vars?: Record<string, string | number | undefined | null>,
) =>
  template?.replace(/{(\w+)}/g, (_, k) =>
    vars?.[k] != null ? String(vars?.[k]) : "",
  ) ?? "";
